import React from 'react'

import { Breadcrumb } from 'react-breadcrumbs'
import { Breadcrumbs } from 'Components/Breadcrumbs'
import SettingsIcon from 'Assets/Images/icons/settings'
import { PATHS } from 'Config/Routing/paths'

export const BreadcrumbsNetPromoterScore = ({ currentPath, className }) => {
  return (
    <div className={className}>
      <Breadcrumbs icon={<SettingsIcon style={{ width: 20 }} />} />
      <Breadcrumb
        data={{
          title: 'Settings',
          pathname: `${PATHS.main.dashboard}${PATHS.dashboard.settings}`,
        }}
      />
      <Breadcrumb
        data={{
          title: 'Net Promoter Score',
          pathname: currentPath,
        }}
      />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/Containers/Settings/NetPromoterScore/BreadcrumbsNetPromoterScore.js